module.exports = __webpack_public_path__ + "static/media/lvjian-zhongliuyiyuan.ae9baa85.jpg";